import React from "react";
import { useRoutes } from "react-router-dom";
import NotFound from "pages/NotFound";
import AIHumanity from "pages/AIHumanity";
import BlogPage from "pages/Blog";
import BlogPost from "pages/Blog/Post";
import AIPerception from "pages/AIPerception";
import DemoPage from "pages/Demo";
import AvatarGallery from "pages/AvatarGallery";
import VoiceAgentDemo from "pages/VoiceAgentDemo";
import VoiceHostDemoPage from "pages/VoiceHostDemo";
import WechatFrontDeskPrototypePage from "pages/WechatFrontDeskPrototype";
import BuildAgentDemo from "pages/BuildAgentDemo";
import EmotionProfileDemo from "pages/EmotionProfileDemo";
import ProductPage from "pages/Products";
import UseCasePage from "pages/UseCases";
import BenchmarksPage from "pages/Benchmarks";

const ProjectRoutes = () => {
  let element = useRoutes([
    { path: "/", element: <AIHumanity /> },
    { path: "aihumanity", element: <AIHumanity /> },
    { path: "blog", element: <BlogPage /> },
    { path: "blog/:postId", element: <BlogPost /> },
    { path: "perception", element: <AIPerception /> },
    { path: "demo", element: <DemoPage /> },
    { path: "demo/avatar-gallery", element: <AvatarGallery /> },
    { path: "demo/voice-agent", element: <VoiceAgentDemo /> },
    { path: "demo/voice-host", element: <VoiceHostDemoPage /> },
    { path: "demo/wechat-front-desk", element: <WechatFrontDeskPrototypePage /> },
    { path: "demo/build-agent", element: <BuildAgentDemo /> },
    { path: "demo/emotion-profile", element: <EmotionProfileDemo /> },
    { path: "products/:slug", element: <ProductPage /> },
    { path: "use-cases/:slug", element: <UseCasePage /> },
    { path: "benchmarks", element: <BenchmarksPage /> },
    { path: "*", element: <NotFound /> },
  ]);

  return element;
};

export default ProjectRoutes;
